"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_includes_1 = __importDefault(require("lodash.includes"));
var canonical_1 = __importDefault(require("@segment/canonical"));
var component_url_1 = __importDefault(require("component-url"));
/**
 * Return a default `options.context.page` object.
 *
 * https://segment.com/docs/spec/page/#properties
 */
function pageDefaults() {
    return {
        path: canonicalPath(),
        referrer: document.referrer,
        search: location.search,
        title: document.title,
        url: canonicalUrl(location.search)
    };
}
/**
 * Return the canonical path for the page.
 */
function canonicalPath() {
    var canon = canonical_1.default();
    if (!canon)
        return window.location.pathname;
    var parsed = component_url_1.default.parse(canon);
    return parsed.pathname;
}
/**
 * Return the canonical URL for the page concat the given `search`
 * and strip the hash.
 */
function canonicalUrl(search) {
    var canon = canonical_1.default();
    if (canon)
        return lodash_includes_1.default(canon, '?') ? canon : canon + search;
    var url = window.location.href;
    var i = url.indexOf('#');
    return i === -1 ? url : url.slice(0, i);
}
/*
 * Exports.
 */
module.exports = pageDefaults;



//////////////////
// WEBPACK FOOTER
// ./~/@segment/analytics.js-core/build/pageDefaults.js
// module id = 833
// module chunks = 0